import React, { createContext, useContext } from 'react';
import useExtPartnerCheckIns from '../hooks/useExtPartnerCheckIns';

// Create context
const ExtPartnerCheckInContext = createContext(null);

/**
 * Provider component for external partner check-in data
 * @param {Object} props - Component props
 * @returns {JSX.Element} Provider component
 */
export const ExtPartnerCheckInProvider = ({ children }) => {
  const checkInData = useExtPartnerCheckIns();
  
  return (
    <ExtPartnerCheckInContext.Provider value={checkInData}>
      {children}
    </ExtPartnerCheckInContext.Provider>
  );
};

/**
 * Custom hook to use the external partner check-in context
 * @returns {Object} External partner check-in context value
 */
export const useExtPartnerCheckInContext = () => {
  const context = useContext(ExtPartnerCheckInContext);
  
  if (!context) {
    throw new Error('useExtPartnerCheckInContext must be used within an ExtPartnerCheckInProvider');
  }
  
  return context;
};

export default ExtPartnerCheckInContext;

